import React from 'react';
import { Typography, IconButton, Popover, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/InfoOutlined';

interface IProps {
  title: string;
  content: string;
  message: string;
}

function EventSearchResult({ title, content, message }: IProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleInformationClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleInformationClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Typography variant='h2' color='primary.dark'>
        {title}
      </Typography>

      <Typography variant='body1'>
        {content}
        {message && (
          <IconButton sx={{ py: 0 }} onClick={handleInformationClick}>
            <InfoIcon fontSize='small' color='error' />
          </IconButton>
        )}
      </Typography>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleInformationClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <Box
          sx={{
            p: 1,
            backgroundColor: 'error.main',
            color: 'error.contrastText',
          }}
        >
          {message}
        </Box>
      </Popover>
    </>
  );
}

export default EventSearchResult;
